import { render, staticRenderFns } from "./AppSchoolSwitcher.vue?vue&type=template&id=3e8671ca&scoped=true&"
import script from "./AppSchoolSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppSchoolSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppSchoolSwitcher.vue?vue&type=style&index=0&id=3e8671ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8671ca",
  null
  
)

export default component.exports